"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.set-prototype-of.js");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _react = _interopRequireDefault(require("react"));
var _core = require("../core");
var _imgixUrl = _interopRequireDefault(require("../helpers/imgixUrl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_132iy94lbk() {
  var path = "/__w/code/code/js/packages/bricks/src/utils/ImgixImg.tsx";
  var hash = "239d1fc9ed3239f3a8dec3a8be0fd2bbacc2a600";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/utils/ImgixImg.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 39
        }
      },
      "1": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "2": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 40
        }
      },
      "3": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 21,
          column: 33
        }
      },
      "4": {
        start: {
          line: 22,
          column: 19
        },
        end: {
          line: 22,
          column: 84
        }
      },
      "5": {
        start: {
          line: 22,
          column: 37
        },
        end: {
          line: 22,
          column: 72
        }
      },
      "6": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 18
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 22,
            column: 31
          }
        },
        loc: {
          start: {
            line: 22,
            column: 37
          },
          end: {
            line: 22,
            column: 72
          }
        },
        line: 22
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "239d1fc9ed3239f3a8dec3a8be0fd2bbacc2a600"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_132iy94lbk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_132iy94lbk();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * A utility component that renders an image from Imgix (o/imgdrop).
 */
var ImgixImg = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(ImgixImg, _React$Component);
  function ImgixImg() {
    _classCallCheck(this, ImgixImg);
    return _callSuper(this, ImgixImg, arguments);
  }
  _createClass(ImgixImg, [{
    key: "render",
    value: function render() {
      cov_132iy94lbk().f[0]++;
      var props = (cov_132iy94lbk().s[0]++, (0, _cloneDeep2["default"])(this.props));
      var baseSrc = (cov_132iy94lbk().s[1]++, props.src);
      var widths = (cov_132iy94lbk().s[2]++, [320, 480, 640, 1024]);
      var src = (cov_132iy94lbk().s[3]++, (0, _imgixUrl["default"])(baseSrc));
      var srcSet = (cov_132iy94lbk().s[4]++, widths.map(function (w) {
        cov_132iy94lbk().f[1]++;
        cov_132iy94lbk().s[5]++;
        return (0, _imgixUrl["default"])("".concat(baseSrc, "?w=").concat(w, " ").concat(w, "w"));
      }).join(', '));
      // Alt is required by ImageProps
      // eslint-disable-next-line jsx-a11y/alt-text
      cov_132iy94lbk().s[6]++;
      return /*#__PURE__*/_react["default"].createElement(_core.Image, _extends({}, props, {
        src: src,
        srcSet: srcSet
      }));
    }
  }]);
  return ImgixImg;
}((_react["default"].Component));